<template>
  <div :class="componentClasses">
    <Loader />
    <div class="stk-loader-with-text-body">
      <slot>
        Loading…
      </slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Loader from './Loader.vue';

const props = defineProps({
  size: {
    type: String,
  },
  resize: {
    type: String,
  },
  inherit: {
    type: Boolean,
  },
});

const componentClasses = computed(() => [
  'stk-loader-with-text',
  props.size ? `stk-size-${props.size}` : '',
  props.resize ? `stk-resize-${props.resize}` : '',
  props.inherit && 'tw-text-inherit',
]);
</script>

<style>
.stk-loader-with-text {
  color: var(--stk-text-weak);
  display: flex;
  align-items: center;
  gap: 1em;
}
</style>
